import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  SelectComponent,
} from '@data-delivery/d3s';
import { type UseFormReturn } from 'react-hook-form';
import { type AssignmentFormValues } from './form-schema';

interface FieldBusinessGroupSelectProps {
  form: UseFormReturn<AssignmentFormValues>;
  options: Array<{ value: string; label: string }>;
  mode: 'create' | 'edit';
  allowBusinessGroupSelection?: boolean;
}

export function FieldBusinessGroupSelect({
  form,
  options,
  mode,
  allowBusinessGroupSelection,
}: FieldBusinessGroupSelectProps) {
  return (
    <FormField
      control={form.control}
      name='businessGroup'
      render={({ field }) => (
        <FormItem>
          <FormLabel>Business Group</FormLabel>
          <FormControl>
            <SelectComponent
              placeholder='Select business group'
              value={
                field.value
                  ? [
                      {
                        value: field.value,
                        label: options.find(o => o.value === field.value)?.label || field.value,
                      },
                    ]
                  : []
              }
              options={options}
              isMulti={false}
              isSearchable
              onChange={val => {
                const selected = Array.isArray(val)
                  ? val[0]
                  : (val as { value: string } | undefined);
                const next = selected?.value || '';
                if (next !== field.value) {
                  form.setValue('products', [], { shouldValidate: true });
                }

                field.onChange(next);
              }}
              isDisabled={!allowBusinessGroupSelection}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
